import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import logoImg from 'Console/assets/images/YeselfLogoWhiteVector.svg';


const styles = (theme) => ({
    bodyContainer: {
        flex: 1,
        backgroundColor: theme.palette.primary.main,
    },
    img: {
        margin: 'auto',
        display: 'block',
    },
});
const NoMatch = ({ classes }) => (
    <div className={classes.bodyContainer}>
        <Grid container direction="row" justify="center" alignItems="center" spacing={0}>
            <Grid item>
                <img className={classes.img} alt="logo" src={logoImg} />
                <Typography component="h1" variant="h6" align="center">
                    404
                </Typography>
            </Grid>
        </Grid>
    </div>
);

export default withStyles(styles)(NoMatch);
